module.exports = __webpack_public_path__ + "media/images/front/icons/top-af03e9340dac82668098d2cb5cab45c9.png";